import React, { Component } from "react";

import "./style.css";

// Import your audio file
import song from "./cancion.mp3";

class PlayMusic extends Component {
  // Create state
  state = {
    // Get audio file in a variable
    audio: new Audio(song),
    // Set initial state of song
    isPlaying: false,
  };

  // Main function to handle both play and pause operations
  playPause = () => {
    // Get state of song
    let isPlaying = this.state.isPlaying;
    if (isPlaying) {
      // Pause the song if it is playing
      this.state.audio.pause();
    } else {
      // Play the song if it is paused
      this.state.audio.play();
    }

    // Change the state of song
    this.setState({ isPlaying: !isPlaying });
  };

  render() {
    return (
      <div>
        {/* Show state of song on website */}
        {/* <p>
          {this.state.isPlaying ? 
            "Song is Playing" : 
            "Song is Paused"}
        </p> */}

        {/* Button to call our main function */}
        <button
          className="button-icon-song shrink-on-hover-button"
          onClick={this.playPause}
        >
          <img
            className="song-icon shrink-on-hover-button"
            src="https://img.icons8.com/android/24/000000/music.png"
            alt="music"
          />
        </button>
      </div>
    );
  }
}

export default PlayMusic;
